import { Component, OnInit,ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { generalService } from '../../services/general.service';
// import { Personal } from '../models/personal';
// import {Familiar} from '../models/familiar';
import {MatPaginator,MatDialog, MatSort} from '@angular/material';
import { DataService } from '../../utils/data.service';

import {DataSourceGrid} from '../../utils/data-source-grid.component';
import { Cliente } from '../../models/cliente';
 @Component({
  selector: 'my-personalcliente',
  styleUrls: [], 
  templateUrl: 'personalCliente.component.html',
  providers: [generalService]
})

 
export class PersonalClienteComponent implements OnInit {
displayedColumns = [ 'Empleado','nombreDireccion' , 'Ubicacion'];
dataSource: DataSourceGrid | null; 
public datosPersonalCliente:Array<any>;
customer_id: string;

 @ViewChild(MatPaginator) paginator: MatPaginator;
 @ViewChild(MatSort) sort: MatSort;

   constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _generalService: generalService,
    public dataService: DataService,
    public dialog: MatDialog
    ) {
    this.customer_id = (this.route.snapshot.paramMap.get('id'));
    this.datosPersonalCliente = new Array();
  }

  ngOnInit() {   
    this.getPersonalCliente(this.customer_id);
  }

  getPersonalCliente(id:any){    
    let cliente = new Cliente();
    cliente.idCliente = id;
    cliente.loacs =  sessionStorage.getItem("acslo");
    this._generalService.metodoCallParams(cliente,`cliente/consultarPersonales/`).subscribe(
      result => {          
        this.datosPersonalCliente = JSON.parse(result);
        this.dataSource = new DataSourceGrid(this.datosPersonalCliente, this.paginator, this.sort);
         if(this.datosPersonalCliente.length <= 0)
          {
            $("#tablePersonalCliente .mat-row").remove(".mat-row");
          }
      },
      error => {
        var errorMsj = <any>error;
        console.log(errorMsj);
      }
    );
  }

  empleado(id:any){
    this.router.navigate(['../../personal/' + id], { relativeTo: this.route });
  }

}


// WEBPACK FOOTER //
// ./src/app/cliente/personalCliente/personalCliente.component.ts